module.exports = __webpack_public_path__ + "img/HEP_NAVIO_Umeda_tc.9901be0f.jpg";